export default __webpack_public_path__ + "static/media/DownCaret.9f5bf9a3.svg";